import i18next from "i18next";
import i18n from "i18next";
import * as constants from '../lib/const.js';
import React from "react";
import {useTranslation} from "react-i18next";


function change_lang(lang_name, off_lang_name) {
    const lang_btn = `${lang_name}-btn`
    const off_lang_btn = `${off_lang_name}-btn`
    i18next.changeLanguage(lang_name);
    document.getElementById(lang_btn).classList.remove(constants.BTN_OFF);
    document.getElementById(lang_btn).classList.add(constants.BTN_ON);
    document.getElementById(off_lang_btn).classList.remove(constants.BTN_ON);
    document.getElementById(off_lang_btn).classList.add(constants.BTN_OFF);
}

function Header() {
    const {t} = useTranslation()
    let lang_styles = {}
    let enable_style = "btn btn-dark m-1 w-40"
    let disable_style = "btn btn-outline-dark m-1 w-40"
    if (i18n.language === "ru"){
        lang_styles["ru"] = enable_style
        lang_styles["en"] = disable_style
    }
    if (i18n.language === "en"){
        lang_styles["ru"] = disable_style
        lang_styles["en"] = enable_style
    }
    return (
        <div className="navbar sticky-lg-bottom" style={{"margin-bottom": 0}}>
            <div className="w-75">
                <a href="/">
                    <button type="button"
                            className="btn btn-outline-dark m-1 btn-block w-20">{t('menu_button')}</button>
                </a>
                <a href="/patients">
                    <button type="button"
                            className="btn btn-outline-dark m-1 btn-block w-20">{t('patient_button')}</button>
                </a>
                <a href="/assays">
                    <button type="button"
                            className="btn btn-outline-dark m-1 btn-block w-20">{t('assay_button')}</button>
                </a>
                <a href="/biobanks">
                    <button type="button"
                            className="btn btn-outline-dark m-1 btn-block w-20">{t('biobank_button')}</button>
                </a>
            </div>
            <div className="col">
                <div className="text-end">
                    <button id="ru-btn" type="button" className={lang_styles['ru']}
                            onClick={() => {
                                change_lang('ru', 'en')
                            }}> Russian
                    </button>
                    <button id="en-btn" type="button" className={lang_styles['en']}
                            onClick={() => {
                                change_lang('en', 'ru')
                            }}> English
                    </button>
                </div>
            </div>
            <br/>
            <br/>
        </div>


    )
}


export default Header